<style src='style.scss'>

</style>

<section class="mbsc-row featured-image">
    <div class="mbsc-col-12">
      <header>
        <h1>¡Únete a D-NS Studio!</h1>
        <p class="mbsc-col-12 mbsc-col-lg-8">
          Tu registro te dará acceso a todas nuestras clases durante 7 días totalmente gratis, las puedes ver cuantas veces quieras, si te gusta nuestro trabajo puedes adquirir tu membresía mensual o anual para seguir teniendo acceso ilimitado.<br>
          Recuerda que además cada semana agregamos nuevas clases para tí.
        </p>
      </header>
    </div>
    <div class="mbsc-col-12 mbsc-offset-md-3 mbsc-col-md-6">
      <div class="mbsc-align-center form-messages">
        <div class="mbsc-note mbsc-note-success">{successMessage}</div>
        <div class="mbsc-note mbsc-note-danger">{dangerMessage}</div>
        <div class="mbsc-note mbsc-note-warning">{warningMessage}</div>
      </div>
      <form class="signup-form">
        <div class="mbsc-form-group">
          <div class="mbsc-form-group-title">Crear una nueva cuenta</div>
          <label>
            <input mbsc-input name="email" id="email" type="email" placeholder="Correo electrónico" required data-icon="user4">
          </label>
          <label>
            <input mbsc-input name="password" id="password" type="password" placeholder="Password" minlength="8" required data-icon="lock2" data-password-toggle="true">
          </label>
          <label>
            <select mbsc-dropdown id="genero" name="genero" required data-icon="user4">
              <option value="">Género</option>
              <option value="female">Femenino</option>
              <option value="male">Masculino</option>
              <option value="other">Otro</option>
              <option value="prefer-no">Prefiero no decir</option>
            </select>
          </label>
          <label>
            Al registrarme acepto la política de privacidad y los términos y condiciones
            <input data-input-style="box" type="checkbox" id="tos" name="tos" />
          </label>
          <label>
            Me gustaría recibir correos electrónicos sobre productos, servicios y contenido relevante basado en mi actividad.
            <input data-input-style="box" type="checkbox" id="marketing" name="marketing" checked />
          </label>
        </div>
        <div class="mbsc-form-group mbsc-btn-group-block">
          <button mbsc-button id="md-success" data-icon="checkmark" on:click={validateForm}>Registrar</button>
        </div>
      </form>
    </div>
  </section>

  <script>
  import { onMount, afterUpdate, beforeUpdate } from 'svelte';
  import { AWSAuth, Navigation } from '@Services';

  const DEBUG = document.location.protocol === 'http:' ? true : false;

  let signupForm = null, addedToFields = false;

  let successMessage = '';
  let warningMessage = '';
  let dangerMessage = '';

  let validateForm = async (event) => {
    event.preventDefault();
    document.querySelector('.mbsc-note.mbsc-note-danger').style.display = 'none';
    dangerMessage = '';
    let formvalid = true;

    for (let f = 0; f < signupForm.elements.length; f++) {
      let field = signupForm.elements[f],
      name = field.name.charAt(0).toUpperCase() + field.name.slice(1),
      parent = field.parentNode,
      errorMsg = parent.querySelector('.mbsc-err-msg');
      if ((name === 'Tos') && (field.checked !== true)) {
        mobiscroll.snackbar({
          message: 'Es necesario aceptar los términos y condiciones.',
          color: 'warning',
          display: 'top',
        });
        formvalid = false;
      }

      if (name && field.validity.valid) {
        parent.parentNode.classList.remove('mbsc-err');

        if (errorMsg) {
          parent.removeChild(errorMsg);
        }
      } else if (name) {
        if (!errorMsg) {
          errorMsg = document.createElement('span');
          errorMsg.className = 'mbsc-err-msg';
          parent.appendChild(errorMsg);
        }

        var firstError = null;
        for (var key in field.validity) {
          if (!firstError && key !== 'valid' && field.validity[key]) {
            firstError = key;
          }
        }
        switch (firstError) {
          case 'tooShort':
          {
            errorMsg.innerHTML = name + ' es demasiado corto';
            break;
          }
          case 'typeMismatch':
          {
            errorMsg.innerHTML = name + ' es inválido';
            break;
          }
          case 'valueMissing':
          default:
          {
            errorMsg.innerHTML = name + ' es requerido';
            break;
          }
        }
        parent.parentNode.classList.add('mbsc-err');
        formvalid = false;
      }
    }

    if (formvalid && (event.type === 'click')) {
      const email = document.querySelector('#email').value;
      const password = document.querySelector('#password').value;
      const genero = document.querySelector('#genero').value;
      const marketing = document.querySelector('#marketing').checked;
      let discountCode = 'D-NS70';

      AWSAuth.signUp(email, password, email, genero, marketing, discountCode).then((response) => {
        if (!response) {
          dangerMessage = 'Ocurrió un error al tratar de crear la cuenta.';
          document.querySelector('.mbsc-note.mbsc-note-danger').style.display = 'block';
          return false;
        } else if (typeof response.code === 'string') {
          if (response.code === 'UsernameExistsException') {
            mobiscroll.alert({
              title: 'Ya existe una cuenta con esa dirección',
              message: 'Intenta iniciar sesión con esa dirección de correo y tu contraseña.',
              callback: () => {
                Navigation.goTo('account');
              },
            });
          }else{
            dangerMessage = response.message;
            document.querySelector('.mbsc-note.mbsc-note-danger').style.display = 'block';
          }
          return false;
        }else if (response.codeDeliveryDetails && response.codeDeliveryDetails.DeliveryMedium === 'EMAIL'){
          if (response.user) {
            const expiration = new Date();
          }
          if (response.userConfirmed === false) {
            mobiscroll.alert({
              title: 'Gracias por registrarte',
              message: 'Hemos enviado un correo de verificación a la dirección ' + response.codeDeliveryDetails.Destination,
              callback: () => {
                Navigation.goTo('account');
              },
            });
          }else{
            mobiscroll.alert({
              title: 'Gracias por registrarte',
              message: 'Tu cuenta ha sido activada correctamente',
              callback: () => {
                Navigation.goTo('account');
              },
            });
          }
        }
      });
    } else if (!addedToFields) {
      addedToFields = true;
    } else if (!formvalid) {
      dangerMessage = 'Ocurrió un error al tratar de crear la cuenta.';
      document.querySelector('.mbsc-note.mbsc-note-danger').style.display = 'block';
    }

    return false;
  };

  afterUpdate(() => {
    mobiscroll.form('.signup-form', {});
  });

  onMount(async () =>{
    signupForm = document.querySelector('.signup-form');
    signupForm.noValidate = true;
  });
</script>
